// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._481dP5glx,._481dP5glx:first-child{padding:0;flex-direction:column;align-items:flex-start}._2eN4AoVmx._62wuzqJVx{padding:0}._2eN4AoVmx._62wuzqJVx._78kup7Gbx,._2eN4AoVmx._62wuzqJVx._78kup7Gbx:hover{background-color:var(--ui-subtle-active)}@media screen and (-ms-high-contrast: active){._2eN4AoVmx._62wuzqJVx._78kup7Gbx,._2eN4AoVmx._62wuzqJVx._78kup7Gbx:hover{background-color:window}._2eN4AoVmx._62wuzqJVx._78kup7Gbx span,._2eN4AoVmx._62wuzqJVx._78kup7Gbx:hover span{color:windowText}}._45YiZDgFx{box-sizing:border-box;width:100%;padding:8px 20px}@media screen and (-ms-high-contrast: active){._78kup7Gbx>._481dP5glx>._45YiZDgFx>svg path{fill:windowText !important}:not(._78kup7Gbx)>._481dP5glx>._45YiZDgFx:hover>svg path{fill:window !important}}._7IMdrMPQx{flex:0 0 auto}._2P61wHSZx{margin-left:20px}._62wuzqJVx ._2P61wHSZx{margin-left:2px}._70bCkJAEx{flex:1 1 auto;margin-left:4px;font-size:14px;line-height:20px;color:var(--primary-text)}._2aLiGnJhx{display:none;width:100%}._2eN4AoVmx._78kup7Gbx._62wuzqJVx ._2aLiGnJhx{display:block}._2t6xzcGCx{font-size:12px;line-height:20px;color:var(--primary-text);padding:4px 20px 4px 48px;flex:1 1 100%;text-decoration:none}@media screen and (-ms-high-contrast: active){._2t6xzcGCx>svg path{fill:windowText !important}}._4vZZQtplx{font-size:12px;line-height:20px;padding:8px 20px 0 47px}a._2t6xzcGCx:hover{background-color:var(--ui-subtle-hover)}@media screen and (-ms-high-contrast: active){a._2t6xzcGCx:hover{background-color:highlight}a._2t6xzcGCx:hover span{color:window !important}a._2t6xzcGCx:hover>svg path{fill:window !important}}._5bFdFNK9x{background-color:var(--ui-subtle-active)}@media screen and (-ms-high-contrast: active){._5bFdFNK9x{background-color:highlight}._5bFdFNK9x span{color:window !important}._5bFdFNK9x>svg path{fill:window !important}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"cell": "_481dP5glx",
	"row": "_2eN4AoVmx",
	"narrow": "_62wuzqJVx",
	"active": "_78kup7Gbx",
	"test": "_45YiZDgFx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"icon": "_7IMdrMPQx",
	"icon-in-group": "_2P61wHSZx _7IMdrMPQx",
	"iconInGroup": "_2P61wHSZx _7IMdrMPQx",
	"title": "_70bCkJAEx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"steps": "_2aLiGnJhx",
	"step": "_2t6xzcGCx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"scenario": "_4vZZQtplx",
	"active-step": "_5bFdFNK9x _2t6xzcGCx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"activeStep": "_5bFdFNK9x _2t6xzcGCx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + ""
};
module.exports = exports;
